// api开发环境地址
const config: Record<string, string> = {
  url: "https://mjnapi2.linkduoo.com/",

};

export default config;
